import React from 'react';
import PropTypes from 'prop-types';

import ExitTestButton from './ExitTestButton';
import styles from './testOverview.scss';
import { cacheResultTypes } from '../../actions/CacheStatusActions';
import { t } from '../../services/i18nService';

const LoadErrorMessage = React.memo(({
    cacheStatus,
    hasEmbeddedOrLinkMedia,
}) => {
    let captionKey;
    if (
        (
            cacheStatus?.result === cacheResultTypes.INCOMPLETE
            || cacheStatus?.result === cacheResultTypes.TIMEOUT
        )
        && hasEmbeddedOrLinkMedia
    ) {
        captionKey = 'childTest.assetDownloadFailed';
    } else if (cacheStatus?.result === cacheResultTypes.TIMEOUT) {
        captionKey = 'childTest.loadingTimedOutAfterLimit';
    } else {
        captionKey = 'childTest.loadingFailed';
    }

    return (
        <div className={`${styles.actionBox} ${styles.current} ${styles.loadProgress}`}>
            <span className={styles.text}><i className="fa fa-exclamation-triangle" aria-hidden /></span>
            <span className={styles.actionBoxLabel}>
                {t(captionKey)}
            </span>
            <ExitTestButton showButtonForNonLockdown />
        </div>
    );
});

LoadErrorMessage.propTypes = {
    cacheStatus: PropTypes.object,
    hasEmbeddedOrLinkMedia: PropTypes.bool,
};

export default LoadErrorMessage;
